export class BaseFilter {
  skip: number;
  take: number;
}
